import { type FilterValue, type FilterDateValue } from '@shared/types/api';

type ExtendedFilterValue =
  | FilterValue
  | FilterDateValue
  | {
      items: (string | Date | null)[];
      operator: string;
    };

export const getActiveFilters = <T extends Record<string, ExtendedFilterValue>>(
  filters: T
): Partial<T> => {
  const result: Partial<T> = {};

  for (const key in filters) {
    const filter = filters[key];

    const hasValidItems =
      filter.operator === 'range'
        ? filter.items &&
          filter.items.length >= 2 &&
          filter.items.every(item => item !== null)
        : filter.items?.length &&
          filter.items?.[0] !== '' &&
          filter.items?.[0] !== null;

    if (hasValidItems) {
      result[key] = filter;
    }
  }

  return result;
};
